module.exports = __webpack_public_path__ + "static/media/tienda_blanco.f7b26725.svg";